import {Routes} from 'constants/routes';

import Button from 'components/Button/Button';
import Search from 'components/Search/Search';
import {useNavigate} from 'react-router-dom';

import './NavbarContent.scss';

interface Props {
  value?: string;
  onChange: (e: string) => void;
}

const NavbarContent = ({value, onChange}: Props) => {
  const navigate = useNavigate();

  const handleNewBeer = () => navigate(Routes.BEERS_NEW);

  return (
    <div className="navbar-content">
      <Search value={value} onChange={onChange} placeholder="Search Beers" />
      <Button variant="primary" onClick={handleNewBeer}>
        New Beer
      </Button>
    </div>
  );
};

export default NavbarContent;
